import React from "react";
import boyDance from "../assets/boyDance.gif";
import girlDance from "../assets/girlDance.gif";

const Modal = ({ openModal, data, onClick }) => {
  // console.log(openModal);

  return (
    <>
      {openModal && (
        <>
          <img
            src={boyDance}
            alt=""
            className="fixed left-[-50px] bottom-0 translate-y-0 sm:top-[50%] sm:translate-y-[-50%] w-[300px] z-40"
          />
          <img
            src={girlDance}
            alt=""
            className="fixed right-[-50px] top-0 translate-y-0 sm:top-[50%] sm:translate-y-[-50%] w-[300px] z-40"
          />
          <div className="h-[100vh] w-[100vw] fixed bg-black/30 backdrop-blur-[50px] z-30 top-0 left-0"></div>
          <div className="max-w-[500px] w-full z-30 p-[10px] fixed top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%]">
            <div className="w-full bg-white aspect-square rounded-[20px] card text-white">
              <div className="h-full flex flex-col justify-evenly items-center">
                <p className="text-[18px]">{data?.gameDateSlot}</p>
                <p className="text-[35px]">Time: {data?.gameTimeSlot}</p>
                <p className="text-[30px]">Color : {data?.colorResult}</p>
                <p className="text-[30px]">
                  Single Number : {data?.singleResult}
                </p>
                <p className="text-[30px]">
                  Double Number : {data?.doubleResult}
                </p>
              </div>
            </div>
          </div>
          <button
            className="button z-30 fixed bottom-[50px] sm:bottom-[50px] sm:left-[50%] sm:translate-x-[-50%] right-[20px] sm:right-auto"
            onClick={onClick}
          >
            Review
          </button>
        </>
      )}
    </>
  );
};

export default Modal;
